import { render } from "./AgenciesIcon.vue?vue&type=template&id=063e2da8"
import script from "./AgenciesIcon.vue?vue&type=script&lang=js"
export * from "./AgenciesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__